export * from './get-external-gate-by-product-id'
